<template>
	<div tabindex="0" class="hide-outline">
		<main class="main-view pl-6">
			<h1 class="title">Changelog</h1>
			<div style="display: block;">
				<div v-for="version in changelog" :key="version.diff" class="mb-5">
					<h2><strong>Version: {{ version.title }}</strong> ({{ version.diff }})</h2>

					<ul class="Changelog-Ul" v-for="commit in version.commits" :key="commit.hash">
						<li>{{ commit.subject }}</li>
					</ul>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import changelog from '../../../CHANGELOG.json';
export default {
	data: () => ({
		changelog
	}),

	methods: {

	}
};
</script>

<style scoped>
	.Changelog-Ul {
		margin-left: 10px;
	}

	.Changelog-Ul li {
		margin-left: 10px;
		list-style: disc;
	}
</style>
